<template>
  <div>
    <div>
      <h1 class="h2 mt-4">Szerződő adatai</h1>
      <div class="row">
        <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <label
                for="szerzodo_vezeteknev"
                class="input-group-text"
                id="szerzodo_vezeteknev-prepend"
                >Vezetéknév: <span class="text-danger">*</span></label
              >
            </div>
            <input
              type="text"
              class="form-control dark-border"
              id="szerzodo_vezeteknev"
              name="szerzodo_vezeteknev"
              v-model="contractorLastName"
              aria-label="Vezetéknév"
              aria-describedby="szerzodo_vezeteknev-prepend"
              :class="classes"
            />
          </div>
          <small id="szerzodo_vezeteknev-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
        <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <label
                for="szerzodo_keresztnev"
                class="input-group-text"
                id="szerzodo_keresztnev-prepend"
                >Keresztnév: <span class="text-danger">*</span></label
              >
            </div>
            <input
              type="text"
              class="form-control dark-border"
              id="szerzodo_keresztnev"
              name="szerzodo_keresztnev"
              v-model="contractorFirstName"
              aria-label="Keresztnév"
              aria-describedby="szerzodo_keresztnev-prepend"
              :class="classes"
            />
          </div>
          <small id="szerzodo_keresztnev-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
      </div>
      <div class="row">
        <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <label
                for="szerzodo_anyja_leanykori_nev"
                class="input-group-text"
                id="szerzodo_anyja_leanykori_nev-prepend"
                >Anyja leánykori neve: <span class="text-danger">*</span></label
              >
            </div>
            <input
              type="text"
              class="form-control dark-border"
              id="szerzodo_anyja_leanykori_nev"
              name="szerzodo_anyja_leanykori_nev"
              v-model="contractorMotherChildName"
              aria-label="Anyja leánykori neve"
              aria-describedby="szerzodo_anyja_leanykori_nev-prepend"
              :class="classes"
            />
          </div>
          <small id="szerzodo_anyja_leanykori_nev-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
        <div class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <label
                for="szerzodo_szuletes_nev"
                class="input-group-text"
                id="szerzodo_szuletes_nev-prepend"
                >Születéskori neve:</label
              >
            </div>
            <input
              type="text"
              class="form-control dark-border"
              id="szerzodo_szuletes_nev"
              name="szerzodo_szuletes_nev"
              v-model="contractorBornName"
              aria-label="Születéskori neve"
              aria-describedby="szerzodo_szuletes_nev-prepend"
            />
          </div>
          <small id="szerzodo_szuletes_nev-error" class="text-danger input-alert"></small>
        </div>
      </div>
      <div class="row">
        <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <label
                for="szerzodo_szuletesi_hely"
                class="input-group-text"
                id="szerzodo_szuletesi_hely-prepend"
                >Születési hely: <span class="text-danger">*</span></label
              >
            </div>
            <input
              type="text"
              class="form-control dark-border"
              id="szerzodo_szuletesi_hely"
              name="szerzodo_szuletesi_hely"
              v-model="contractorBornCity"
              aria-label="Születési hely"
              aria-describedby="szerzodo_szuletesi_hely-prepend"
              :class="classes"
            />
          </div>
          <small id="szerzodo_szuletesi_hely-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
        <div class="col-md-6 mb-3">
          <div class="input-group flex-nowrap">
            <div class="input-group-prepend dark-border">
              <span class="input-group-text" id="szerzodo_szuletesi_datum-prepend"
                >Születési dátum: <span class="text-danger">*</span></span
              >
            </div>
            <input
              class="form-control dark-border"
              name="szerzodo_szuletesi_datum"
              type="date"
              :min="birthMinDate"
              :max="birthMaxDate"
              v-model="contractorBornDate"
              required
            />
            <!-- <Datepicker
                id="szerzodo_szuletesi_datum_dp4"
                name="szerzodo_szuletesi_datum"
                :format="'yyyy-MM-dd'"
                :placeholder="'Kattintson ide a dátum kiválasztásához'"
                :language="hu"
                :disabled-dates="contractedIsInsured ? biztDisabledDates : bornDisabledDates"
                :typeable="false"
                input-class="form-control dark-border"
                :open-date="bornInitialDate"
                required
                v-model="contractorBornDate"
                aria-label="Születési dátum"
                aria-describedby="szerzodo_szuletesi_datum-prepend"
                class="datepicker-prepend-input dark-border"
              ></Datepicker> -->
          </div>
          <ValidationProvider
            :immediate="true"
            rules="required|szerzodes_szuletes_datum"
            v-slot="{errors}"
          >
            <input
              type="text"
              name="szerzodo_szuletesi_datum"
              :value="contractorBornDate"
              disabled
              hidden
            />
            <small class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
      </div>
      <div class="text-danger fw-normal mb-3">
        Figyelem! A szerződő e-mail címének visszaigazolásának céljából egy 6 számjegyből álló kódot
        tartalmazó levelet küldünk az Ön által megadott e-mail címre. Kérjük, írja be ezt a számsort
        a következő oldalon erre kijelölt helyen.
        <ul>
          <li>
            Fontos, hogy akkor is adjon meg e-mail címet, ha a kapcsolattartáshoz a postai
            kommunikációt választja.
          </li>
          <li>Az e-mail cím megerősítése nélkül a biztosításkötés nem lehetséges.</li>
        </ul>
        A visszaigazoló kód érvényessége: 30 perc.
      </div>
      <div class="form-group row mb-3">
        <label for="szerzodo_email" class="col-sm-4">
          Szerződő e-mail címe: <span class="text-danger">*</span>
        </label>
        <ValidationProvider
          :rules="{required: electronicContact == 1 ? true : false, email: true}"
          id="szerzodo_email"
          v-slot="{errors, classes}"
          class="col-sm-8"
        >
          <input
            type="email"
            class="form-control dark-border"
            id="szerzodo_email"
            name="szerzodo_email"
            v-model="contractorEmail"
            :class="classes"
            :readonly="emailVerified"
          />
          <small id="szerzodo_email-error" class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
      <div class="form-group row mb-3">
        <label for="szerzodo_email_2" class="col-sm-4"
          >Szerződő e-mail címének ismételt megadása:
          <span class="text-danger" v-if="contractorEmail != ''">*</span></label
        >
        <ValidationProvider
          :rules="{required_if: 'szerzodo_email', email: true, is: contractorEmail}"
          v-slot="{errors, classes}"
          class="col-sm-8"
        >
          <input
            type="email"
            class="form-control dark-border"
            id="szerzodo_email_2"
            name="szerzodo_email_2"
            v-model="contractorEmailVerification"
            :class="classes"
            :readonly="emailVerified"
          />
          <small id="szerzodo_email_2-error" class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
      <div class="text-danger mb-3">
        Az e-mail cím megerősítése után az e-mail cím módosítása a későbbiekben már nem lehetséges.
      </div>
      <div class="form-group row">
        <label class="col-sm-4" for="szerzodo_telefonszam"
          >Szerződő telefonszáma: <span class="text-danger">*</span></label
        >
        <ValidationProvider rules="required|max:2" v-slot="{errors, classes}" class="col-sm-3 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <span class="input-group-text" id="szerzodo_telefonszam_korzet_prepend">+36</span>
            </div>
            <input
              type="number"
              min="1"
              max="99"
              class="form-control dark-border"
              id="szerzodo_telefonszam_korzet"
              name="szerzodo_telefonszam_korzet"
              aria-label="Körzetszám"
              aria-describedby="szerzodo_telefonszam_korzet_prepend"
              v-model.number="contractorPhoneNumberArea"
              :class="classes"
            />
          </div>
          <small id="szerzodo_telefonszam_korzet-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
        <ValidationProvider
          rules="required|min:6|max:7"
          v-slot="{errors, classes}"
          class="col-sm-5"
        >
          <input
            type="number"
            class="form-control dark-border"
            id="szerzodo_telefonszam"
            name="szerzodo_telefonszam"
            v-model="contractorPhoneNumber"
            :class="classes"
          />
          <small id="szerzodo_telefonszam-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
      </div>
    </div>
    <h1 class="h2 mt-4">Kockázatviselés kezdete</h1>
    <div class="form-group row">
      <label class="col-sm-4" for="kockazat_kezdete"
        >Kockázatviselés kezdete: <span class="text-danger">*</span></label
      >
      <div class="col-sm-8">
        <input
          id="kockazat_kezdete"
          autocomplete="off"
          class="form-control dark-border"
          type="date"
          name="kockazat_kezdete"
          :min="riskStartMinDate"
          :max="riskStartMaxDate"
          v-model="startDate"
          required
        />
        <!-- <Datepicker
          id="kockazat_kezdete"
          name="kockazat_kezdete"
          :format="'yyyy-MM-dd'"
          :placeholder="'ÉÉÉÉ-HH-NN'"
          :language="hu"
          :disabled-dates="riskStartDisabledDates"
          :typeable="true"
          input-class="form-control dark-border"
          required
          v-model="startDate"
        ></Datepicker> -->
        <ValidationProvider :immediate="true" rules="required|kockazat_kezdet" v-slot="{errors}">
          <!-- <input type="text" name="kockazat_kezdete" :value="startDate" disabled hidden /> -->
          <input v-show="false" type="text" :value="startDate" readonly />
          <small class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
    </div>
    <div>
      <h1 class="h2 mt-4">Kockázatviselés helye</h1>
      <div class="row">
        <div class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <label for="kockazat_irsz" class="input-group-text" id="kockazat_irsz-prepend"
                >Irányítószám: <span class="text-danger">*</span></label
              >
            </div>
            <input
              type="number"
              class="form-control dark-border"
              id="kockazat_irsz"
              readonly
              :value="propertyZip"
              aria-label="Irányítószám"
              aria-describedby="kockazat_irsz-prepend"
            />
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <label
                for="kockazat_telepules"
                class="input-group-text"
                id="kockazat_telepules-prepend"
                >Település neve: <span class="text-danger">*</span></label
              >
            </div>
            <input
              type="text"
              class="form-control dark-border"
              id="kockazat_telepules"
              disabled
              :value="selectedPropertyName"
              aria-label="Település neve"
              aria-describedby="kockazat_telepules-prepend"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <label for="kozterulet" class="input-group-text" id="kozterulet-prepend"
                >Közterület neve: <span class="text-danger">*</span></label
              >
            </div>
            <input
              type="text"
              class="form-control dark-border"
              id="kozterulet"
              name="kozterulet"
              v-model="locationName"
              aria-label="Közterület neve"
              aria-describedby="kozterulet-prepend"
              :class="classes"
            />
          </div>
          <small id="kozterulet-error" class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
        <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <label
                for="kozterulet_jellege"
                class="input-group-text"
                id="kozterulet_jellege-prepend"
                >Közterület jellege: <span class="text-danger">*</span></label
              >
            </div>
            <input
              type="text"
              class="form-control dark-border"
              id="kozterulet_jellege"
              name="kozterulet_jellege"
              v-model="locationType"
              aria-label="Közterület jellege"
              aria-describedby="kozterulet_jellege-prepend"
              :class="classes"
            />
          </div>
          <small id="kozterulet_jellege-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
      </div>
      <div class="row">
        <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <label for="hazszam" class="input-group-text" id="hazszam-prepend"
                >Házszám: <span class="text-danger">*</span></label
              >
            </div>
            <input
              type="text"
              class="form-control dark-border"
              id="hazszam"
              name="hazszam"
              v-model="locationHouseNumber"
              aria-label="Házszám"
              aria-describedby="hazszam-prepend"
              :class="classes"
            />
          </div>
          <small id="hazszam-error" class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
        <div class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <label for="kockazat_epl" class="input-group-text" id="kockazat_epl-prepend"
                >Épület, emelet, ajtó:</label
              >
            </div>
            <input
              type="text"
              class="form-control dark-border"
              id="kockazat_epl"
              name="kockazat_epl"
              v-model="locationBuilding"
              aria-label="Épület, emelet, ajtó"
              aria-describedby="kockazat_epl-prepend"
            />
          </div>
          <small id="kockazat_epl-error" class="text-danger input-alert"></small>
        </div>
      </div>
      <div class="form-group row mb-3">
        <label class="col-sm-4" for="kockazat_helyrajzi_szam"
          >Helyrajzi szám:
          <span
            class="info"
            id="kockazat_helyrajzi_szam-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
            >?</span
          ></label
        >
        <div class="col-sm-8">
          <input
            class="form-control dark-border"
            type="text"
            id="kockazat_helyrajzi_szam"
            name="kockazat_helyrajzi_szam"
            v-model="locationTopography"
          />
        </div>
      </div>
      <div class="form-group row mb-3">
        <label class="col-sm-4"
          >A szerződő levelezési címe megegyezik a kockázatviselési hellyel?</label
        >
        <div class="col-sm-8">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="szerzodo_levelezes_egyezik"
              id="szerzodo_levelezes_egyezik_igen"
              :value="1"
              v-model="postAddressIsTheSame"
            />
            <label class="form-check-label" for="szerzodo_levelezes_egyezik_igen">
              Igen
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="szerzodo_levelezes_egyezik"
              id="szerzodo_levelezes_egyezik_nem"
              :value="0"
              v-model="postAddressIsTheSame"
            />
            <label class="form-check-label" for="szerzodo_levelezes_egyezik_nem">
              Nem
            </label>
          </div>
        </div>
      </div>
      <div v-show="!postAddressIsTheSame">
        <div class="row">
          <ValidationProvider
            :rules="{
              required: true,
              min: 4,
              max: 4,
              min_value: 1000,
              max_value: 9999,
            }"
            v-slot="{errors, classes}"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <label
                  for="szerzodo_levelezes_irsz"
                  class="input-group-text"
                  id="szerzodo_levelezes_irsz-prepend"
                  >Irányítószám: <span class="text-danger">*</span></label
                >
              </div>
              <input
                type="number"
                class="form-control dark-border"
                id="szerzodo_levelezes_irsz"
                name="szerzodo_levelezes_irsz"
                :value="propertyZip"
                aria-label="Irányítószám"
                aria-describedby="szerzodo_levelezes_irsz-prepend"
                :class="classes"
                v-if="postAddressIsTheSame"
              />

              <div class="flex-grow-1" v-else>
                <!-- <Select2
                  id="szerzodo_levelezes_irsz"
                  name="szerzodo_levelezes_irsz"
                  v-model="contractorLocationZip"
                  :options="zipCodes"
                  :settings="{selectionCssClass: 'w-full'}"
                /> -->
                <input
                  type="text"
                  id="szerzodo_levelezes_irsz"
                  name="szerzodo_levelezes_irsz"
                  v-model="contractorLocationZip"
                  class="form-control dark-border"
                />
              </div>
            </div>
            <small id="szerzodo_levelezes_irsz-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
          <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <label
                  for="szerzodo_levelezes_telepules"
                  class="input-group-text"
                  id="szerzodo_levelezes_telepules-prepend"
                  >Település neve: <span class="text-danger">*</span></label
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_levelezes_telepules"
                name="szerzodo_levelezes_telepules"
                :value="selectedPropertyName"
                aria-label="Település neve"
                aria-describedby="szerzodo_levelezes_telepules-prepend"
                :class="classes"
                v-if="postAddressIsTheSame"
              />

              <template v-else>
                <div class="flex-grow-1" v-if="mailingCityNames.length > 1">
                  <Select2
                    name="szerzodo_levelezes_telepules"
                    v-model="contractorSelectedLocationName"
                    :options="mailingCityNames"
                    :settings="{selectionCssClass: 'w-full'}"
                  />
                </div>

                <input
                  v-else
                  type="text"
                  class="form-control dark-border"
                  readonly
                  :class="classes"
                  name="szerzodo_levelezes_telepules"
                  :value="contractorSelectedLocationName"
                />
              </template>
            </div>
            <small id="szerzodo_levelezes_telepules-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
        </div>

        <div class="row">
          <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <label
                  for="szerzodo_levelezes_kozterulet"
                  class="input-group-text"
                  id="szerzodo_levelezes_kozterulet-prepend"
                  >Közterület neve: <span class="text-danger">*</span></label
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_levelezes_kozterulet"
                name="szerzodo_levelezes_kozterulet"
                :value="locationName"
                aria-label="Közterület neve"
                aria-describedby="szerzodo_levelezes_kozterulet-prepend"
                :class="classes"
                v-if="postAddressIsTheSame"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_levelezes_kozterulet"
                name="szerzodo_levelezes_kozterulet"
                v-model="contractorLocationName"
                aria-label="Közterület neve"
                aria-describedby="szerzodo_levelezes_kozterulet-prepend"
                :class="classes"
                v-else
              />
            </div>
            <small id="szerzodo_levelezes_kozterulet-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
          <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <label
                  for="szerzodo_levelezes_jelleg"
                  class="input-group-text"
                  id="szerzodo_levelezes_jelleg-prepend"
                  >Közterület jellege: <span class="text-danger">*</span></label
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_levelezes_jelleg"
                name="szerzodo_levelezes_jelleg"
                :value="locationType"
                aria-label="Közterület jellege"
                aria-describedby="szerzodo_levelezes_jelleg-prepend"
                :class="classes"
                v-if="postAddressIsTheSame"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_levelezes_jelleg"
                name="szerzodo_levelezes_jelleg"
                v-model="contractorLocationType"
                aria-label="Közterület jellege"
                aria-describedby="szerzodo_levelezes_jelleg-prepend"
                :class="classes"
                v-else
              />
            </div>
            <small id="szerzodo_levelezes_jelleg-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
        </div>
        <div class="row">
          <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <label
                  for="szerzodo_levelezes_hazszam"
                  class="input-group-text"
                  id="szerzodo_levelezes_hazszam-prepend"
                  >Házszám: <span class="text-danger">*</span></label
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_levelezes_hazszam"
                name="szerzodo_levelezes_hazszam"
                :value="locationHouseNumber"
                aria-label="Házszám"
                aria-describedby="szerzodo_levelezes_hazszam-prepend"
                :class="classes"
                v-if="postAddressIsTheSame"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_levelezes_hazszam"
                name="szerzodo_levelezes_hazszam"
                v-model="contractorLocationHouseNumber"
                aria-label="Házszám"
                aria-describedby="szerzodo_levelezes_hazszam-prepend"
                :class="classes"
                v-else
              />
            </div>
            <small id="szerzodo_levelezes_hazszam-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
          <div class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <label
                  for="szerzodo_levelezes_epl"
                  class="input-group-text"
                  id="szerzodo_levelezes_epl-prepend"
                  >Épület, emelet, ajtó:</label
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_levelezes_epl"
                name="szerzodo_levelezes_epl"
                :value="locationBuilding"
                aria-label="Épület, emelet, ajtó"
                aria-describedby="szerzodo_levelezes_epl-prepend"
                v-if="postAddressIsTheSame"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_levelezes_epl"
                name="szerzodo_levelezes_epl"
                v-model="contractorLocationBuilding"
                aria-label="Épület, emelet, ajtó"
                aria-describedby="szerzodo_levelezes_epl-prepend"
                v-else
              />
            </div>
            <small id="szerzodo_levelezes_epl-error" class="text-danger input-alert"></small>
          </div>
        </div>
      </div>
    </div>
    <div>
      <h1 class="h2 mt-4">Biztosított adatai</h1>
      <div class="form-group row mb-3">
        <label class="col-sm-4"
          >A szerződő személye megegyezik a biztosított ingatlan/ingóság
          tulajdonosával/bérlőjével?</label
        >
        <div class="col-sm-8">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="szerzodo_biztositott"
              id="szerzodo_biztositott_igen"
              :value="1"
              v-model="contractedIsInsured"
            />
            <label class="form-check-label" for="szerzodo_biztositott_igen">
              Igen
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="szerzodo_biztositott"
              id="szerzodo_biztositott_nem"
              :value="0"
              v-model="contractedIsInsured"
            />
            <label class="form-check-label" for="szerzodo_biztositott_nem">
              Nem
            </label>
          </div>
        </div>
      </div>
      <div v-show="!contractedIsInsured">
        <div class="row">
          <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <label
                  for="biztositott_vezeteknev"
                  class="input-group-text"
                  id="biztositott_vezeteknev_prepend"
                  >Vezetéknév: <span class="text-danger">*</span></label
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="biztositott_vezeteknev"
                name="biztositott_vezeteknev"
                :value="contractorLastName"
                aria-label="Vezetéknév"
                aria-describedby="biztositott_vezeteknev_prepend"
                :class="classes"
                v-if="contractedIsInsured"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="biztositott_vezeteknev"
                name="biztositott_vezeteknev"
                v-model="insuredLastName"
                aria-label="Vezetéknév"
                aria-describedby="biztositott_vezeteknev_prepend"
                :class="classes"
                v-else
              />
            </div>
            <small id="biztositott_vezeteknev-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
          <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <label
                  for="biztositott_keresztnev"
                  class="input-group-text"
                  id="biztositott_keresztnev_prepend"
                  >Keresztnév: <span class="text-danger">*</span></label
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="biztositott_keresztnev"
                name="biztositott_keresztnev"
                :value="contractorFirstName"
                aria-label="Keresztnév"
                aria-describedby="biztositott_keresztnev_prepend"
                :class="classes"
                v-if="contractedIsInsured"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="biztositott_keresztnev"
                name="biztositott_keresztnev"
                v-model="insuredFirstName"
                aria-label="Keresztnév"
                aria-describedby="biztositott_keresztnev_prepend"
                :class="classes"
                v-else
              />
            </div>
            <small id="biztositott_keresztnev-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
        </div>
        <div class="row">
          <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <label
                  for="biztositott_anyja_leanykori_nev"
                  class="input-group-text"
                  id="biztositott_anyja_leanykori_nev_prepend"
                  >Anyja leánykori neve: <span class="text-danger">*</span></label
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="biztositott_anyja_leanykori_nev"
                name="biztositott_anyja_leanykori_nev"
                :value="contractorMotherChildName"
                aria-label="Anyja leánykori neve"
                aria-describedby="biztositott_anyja_leanykori_nev_prepend"
                :class="classes"
                v-if="contractedIsInsured"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="biztositott_anyja_leanykori_nev"
                name="biztositott_anyja_leanykori_nev"
                v-model="insuredMotherChildName"
                aria-label="Anyja leánykori neve"
                aria-describedby="biztositott_anyja_leanykori_nev_prepend"
                :class="classes"
                v-else
              />
            </div>
            <small id="biztositott_anyja_leanykori_nev-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
          <div class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <label
                  for="biztositott_szuletes_nev"
                  class="input-group-text"
                  id="biztositott_szuletes_nev_prepend"
                  >Születéskori neve:</label
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="biztositott_szuletes_nev"
                name="biztositott_szuletes_nev"
                :value="contractorBornName"
                aria-label="Keresztnév"
                aria-describedby="biztositott_szuletes_nev_prepend"
                v-if="contractedIsInsured"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="biztositott_szuletes_nev"
                name="biztositott_szuletes_nev"
                v-model="insuredBornName"
                aria-label="Keresztnév"
                aria-describedby="biztositott_szuletes_nev_prepend"
                v-else
              />
            </div>
            <small id="biztositott_szuletes_nev-error" class="text-danger input-alert"></small>
          </div>
        </div>
        <div class="row">
          <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <label
                  for="biztositott_szuletesi_hely"
                  class="input-group-text"
                  id="biztositott_szuletesi_hely-prepend"
                  >Születési hely: <span class="text-danger">*</span></label
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="biztositott_szuletesi_hely"
                name="biztositott_szuletesi_hely"
                :value="contractorBornCity"
                aria-label="Születési hely"
                aria-describedby="biztositott_szuletesi_hely-prepend"
                :class="classes"
                v-if="contractedIsInsured"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="biztositott_szuletesi_hely"
                name="biztositott_szuletesi_hely"
                v-model="insuredBornCity"
                aria-label="Születési hely"
                aria-describedby="biztositott_szuletesi_hely-prepend"
                :class="classes"
                v-else
              />
            </div>
            <small id="biztositott_szuletesi_hely-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
          <div class="col-md-6 mb-3">
            <div class="input-group flex-nowrap">
              <div class="input-group-prepend dark-border">
                <label
                  for="biztositott_szuletett"
                  class="input-group-text"
                  id="biztositott_szuletett-prepend"
                  >Születési dátum: <span class="text-danger">*</span></label
                >
              </div>
              <input
                v-if="contractedIsInsured"
                id="biztositott_szuletett"
                name="biztositott_szuletett"
                class="form-control dark-border"
                type="date"
                :min="birthMinDate"
                :max="birthMaxDate"
                v-model="contractorBornDate"
                required
              />
              <input
                v-else
                id="biztositott_szuletett"
                name="biztositott_szuletett"
                class="form-control dark-border"
                type="date"
                :min="birthMinDate"
                :max="birthMaxDate"
                v-model="insuredBornDate"
                required
              />
              <!-- <Datepicker
                id="biztositott_szuletett"
                name="biztositott_szuletett"
                :format="'yyyy-MM-dd'"
                :placeholder="'ÉÉÉÉ-HH-NN'"
                :language="hu"
                :disabled-dates="bornDisabledDates"
                :typeable="true"
                input-class="form-control dark-border"
                :open-date="bornInitialDate"
                required
                :value="contractorBornDate"
                aria-label="Születési dátum"
                aria-describedby="biztositott_szuletett-prepend"
                class="datepicker-prepend-input"
                v-if="contractedIsInsured"
              ></Datepicker>
              <Datepicker
                id="biztositott_szuletett"
                name="biztositott_szuletett"
                :format="'yyyy-MM-dd'"
                :placeholder="'ÉÉÉÉ-HH-NN'"
                :language="hu"
                :disabled-dates="bornDisabledDates"
                :typeable="true"
                input-class="form-control dark-border"
                :open-date="bornInitialDate"
                required
                v-model="insuredBornDate"
                aria-label="Születési dátum"
                aria-describedby="biztositott_szuletett-prepend"
                class="datepicker-prepend-input"
                v-else
              ></Datepicker> -->
            </div>
            <ValidationProvider
              :immediate="true"
              rules="required|szerzodes_szuletes_datum"
              v-slot="{errors}"
              v-if="!contractedIsInsured"
            >
              <input
                type="text"
                name="biztositott_szuletett"
                :value="insuredBornDate"
                disabled
                hidden
              />
              <small class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
        </div>
        <div class="form-group row mb-3">
          <label for="biztositott_email" class="col-sm-4"
            >E-mail cím: <span class="text-danger">*</span></label
          >
          <ValidationProvider
            :rules="{required: electronicContact == 1 ? true : false, email: true}"
            v-slot="{errors, classes}"
            class="col-sm-8"
          >
            <input
              type="email"
              class="form-control dark-border"
              id="biztositott_email"
              name="biztositott_email"
              :value="contractorEmail"
              :class="classes"
              v-if="contractedIsInsured"
            />
            <input
              type="email"
              class="form-control dark-border"
              id="biztositott_email"
              name="biztositott_email"
              v-model="insuredEmail"
              :class="classes"
              v-else
            />
            <small id="biztositott_email-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
        </div>
        <div class="form-group row">
          <label class="col-sm-4" for="biztositott_telefonszam"
            >Biztosított telefonszáma: <span class="text-danger">*</span></label
          >
          <ValidationProvider
            rules="required|max:2"
            v-slot="{errors, classes}"
            class="col-sm-3 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="biztositott_telefonszam_korzet_prepend"
                  >+36</span
                >
              </div>
              <input
                type="number"
                min="1"
                max="99"
                class="form-control dark-border"
                id="biztositott_telefonszam_korzet"
                name="biztositott_telefonszam_korzet"
                aria-label="Körzetszám"
                aria-describedby="biztositott_telefonszam_korzet_prepend"
                :value="contractorPhoneNumberArea"
                :class="classes"
                v-if="contractedIsInsured"
              />
              <input
                type="number"
                min="1"
                max="99"
                class="form-control dark-border"
                id="biztositott_telefonszam_korzet"
                name="biztositott_telefonszam_korzet"
                aria-label="Körzetszám"
                aria-describedby="biztositott_telefonszam_korzet_prepend"
                v-model.number="insuredPhoneNumberArea"
                :class="classes"
                v-else
              />
            </div>
            <small id="biztositott_telefonszam_korzet-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
          <ValidationProvider
            rules="required|min:6|max:7"
            v-slot="{errors, classes}"
            class="col-sm-5"
          >
            <input
              type="number"
              class="form-control dark-border"
              id="biztositott_telefonszam"
              name="biztositott_telefonszam"
              :value="contractorPhoneNumber"
              :class="classes"
              v-if="contractedIsInsured"
            />
            <input
              type="number"
              class="form-control dark-border"
              id="biztositott_telefonszam"
              name="biztositott_telefonszam"
              v-model="insuredPhoneNumber"
              :class="classes"
              v-else
            />
            <small id="biztositott_telefonszam-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
        </div>
      </div>
    </div>
    <div v-if="contractFor !== 3">
      <h1 class="h2 mt-4">
        Jelzálog
        <span
          class="info"
          id="jelzalog-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
          >?</span
        >
      </h1>
      <div class="form-group row mb-3">
        <label class="col-sm-4">Az ingatlan jelzáloggal terhelt?</label>
        <div class="col-sm-8">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="ingatlan_jelzalog"
              id="ingatlan_jelzalog_igen"
              :value="1"
              v-model="propertyIsMortgaged"
            />
            <label class="form-check-label" for="ingatlan_jelzalog_igen">
              Igen
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="ingatlan_jelzalog"
              id="ingatlan_jelzalog_nem"
              :value="0"
              v-model="propertyIsMortgaged"
            />
            <label class="form-check-label" for="ingatlan_jelzalog_nem">
              Nem
            </label>
          </div>
        </div>
      </div>
      <div v-if="propertyIsMortgaged">
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="jelzalog_hitelezo_azon"
            >Hitelező cég neve: <span class="text-danger">*</span></label
          >
          <ValidationProvider
            rules="required"
            v-slot="{errors, classes}"
            name="mező"
            class="col-sm-4"
          >
            <select
              class="form-select dark-border"
              name="jelzalog_hitelezo_azon"
              id="jelzalog_hitelezo_azon"
              :class="classes"
              v-model="mortgageBank"
            >
              <option :value="null">Kérem válasszon</option>
              <option :value="'0000000000'">Manuálisan megadom</option>
              <option :value="bank.id" v-for="(bank, key) in banks" :key="key">
                {{ bank.name }}
              </option>
            </select>
            <small id="jelzalog_hitelezo_azon-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
          <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-sm-4">
            <input
              type="text"
              class="form-control dark-border"
              id="jelzalog_hitelezo_nev"
              name="jelzalog_hitelezo_nev"
              v-model="mortgageCreditor"
              :class="classes"
              :readonly="mortgageBank != '0000000000'"
            />
            <small id="jelzalog_hitelezo_nev-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="jelzalog_hitelezo_szekhely">Hitelező cég székhelye:</label>
          <div class="col-sm-8">
            <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-sm-4">
              <input
                type="text"
                class="form-control dark-border"
                :class="classes"
                id="jelzalog_hitelezo_szekhely"
                name="jelzalog_hitelezo_szekhely"
                v-model="mortgageCreditorLocation"
              />
              <small id="jelzalog_hitelezo_nev-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
          </div>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="jelzalog_azonosito"
            >Hitelszerződés azonosítója: <span class="text-danger">*</span></label
          >
          <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-sm-8">
            <input
              type="text"
              class="form-control dark-border"
              id="jelzalog_azonosito"
              name="jelzalog_azonosito"
              :class="classes"
              v-model="mortgageId"
            />
            <small id="jelzalog_azonosito-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="jelzalog_hitel_osszeg"
            >Hitel összege és devizaneme: <span class="text-danger">*</span></label
          >
          <ValidationProvider
            rules="required|min_value:1"
            v-slot="{errors, classes}"
            class="col-sm-6"
          >
            <input
              type="text"
              class="form-control dark-border"
              id="jelzalog_hitel_osszeg"
              name="jelzalog_hitel_osszeg"
              :class="classes"
              v-model="mortgagePrice"
            />
            <small id="jelzalog_hitel_osszeg-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
          <div class="col-sm-2">
            <select
              name="jelzalog_hitel_deviza"
              id="jelzalog_hitel_deviza"
              class="form-select"
              v-model="mortgageCurrency"
            >
              <option :value="null">Nincs kiválasztva</option>
              <option value="AUD">AUD</option>
              <option value="CAD">CAD</option>
              <option value="CHF">CHF</option>
              <option value="CZK">CZK</option>
              <option value="EUR">EUR</option>
              <option value="GBP">GBP</option>
              <option value="HRK">HRK</option>
              <option value="HUF">HUF</option>
              <option value="PLN">PLN</option>
              <option value="RON">RON</option>
              <option value="SEK">SEK</option>
              <option value="TRY">TRY</option>
              <option value="USD">USD</option>
            </select>
          </div>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="jelzalog_hitel_kezdete">Hitel kezdete:</label>
          <div class="col-sm-8">
            <input
              id="jelzalog_hitel_kezdete"
              name="jelzalog_hitel_kezdete"
              class="form-control dark-border"
              type="date"
              v-model="mortgageStartDate"
              min="1900-01-01"
              max="9999-12-31"
              required
            />
            <!-- <Datepicker
              id="jelzalog_hitel_kezdete"
              name="jelzalog_hitel_kezdete"
              :format="'yyyy-MM-dd'"
              :placeholder="'ÉÉÉÉ-HH-NN'"
              :language="hu"
              :typeable="true"
              input-class="form-control dark-border"
              v-model="mortgageStartDate"
            ></Datepicker> -->
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4" for="jelzalog_hitel_lejarat">Hitel lejárata:</label>
          <div class="col-sm-8">
            <!-- <Datepicker
              id="jelzalog_hitel_lejarat"
              name="jelzalog_hitel_lejarat"
              :format="'yyyy-MM-dd'"
              :placeholder="'ÉÉÉÉ-HH-NN'"
              :language="hu"
              :typeable="true"
              input-class="form-control dark-border"
              v-model="mortgageEndDate"
            ></Datepicker> -->
            <input
              id="jelzalog_hitel_lejarat"
              name="jelzalog_hitel_lejarat"
              class="form-control dark-border"
              type="date"
              min="1900-01-01"
              max="9999-12-31"
              v-model="mortgageEndDate"
              required
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {mapFields} from 'vuex-map-fields';
import {hu} from 'vuejs-datepicker/dist/locale';
import Select2 from 'v-select2-component';
import moment from 'moment';

export default {
  components: {
    Datepicker,
    Select2,
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
    const minDate = new Date();
    minDate.setFullYear(1900);
    minDate.setMonth(1);
    minDate.setDate(1);
    const maxDate = new Date();
    maxDate.setFullYear(today.getFullYear() - 18);
    const birthMinDate = moment(minDate).format('YYYY-MM-DD');
    const birthMaxDate = moment(maxDate).format('YYYY-MM-DD');

    const mortgageStartDateMin = moment('1900-01-01').format('YYYY-MM-DD');
    const mortgageStartDateMax = moment().format('YYYY-MM-DD');
    const mortgageEndDateMin = moment().format('YYYY-MM-DD');
    const mortgageEndDateMax = moment('2999-12-31').format('YYYY-MM-DD');
    const riskStartMinDate = moment(new Date(new Date().setDate(now.getDate() + 1))).format(
      'YYYY-MM-DD'
    );
    const riskStartMaxDate = moment(new Date(new Date().setDate(now.getDate() + 90))).format(
      'YYYY-MM-DD'
    );
    return {
      hu: hu,
      yearlyDefaultPrice: 0,
      accessorySumPrice: 0,
      discountPrice: 0,
      birthMinDate,
      birthMaxDate,
      riskStartMinDate,
      riskStartMaxDate,
      mortgageStartDateMin,
      mortgageStartDateMax,
      mortgageEndDateMin,
      mortgageEndDateMax,
      frequencyPrice: 0,
      mortgageBank: null,
      bornInitialDate: maxDate,
      mailingCityNames: [],
      riskStartDisabledDates: {
        customPredictor: function(date) {
          const maxDate = new Date().setDate(now.getDate() + 90);
          return date < now || date > maxDate;
        },
      },
      bornDisabledDates: {
        customPredictor: function(date) {
          return date > maxDate || date < minDate;
        },
      },
    };
  },
  computed: {
    ...mapFields([
      'contractorPropertyZipChanged',

      'generalInfo.contractFor',
      'riskSettings.startDate',
      'generalInfo.propertyZip',
      'generalInfo.propertyName',
      'generalInfo.selectedPropertyName',
      'riskSettings.locationName',
      'riskSettings.locationType',
      'riskSettings.locationHouseNumber',
      'riskSettings.locationBuilding',
      'riskSettings.locationTopography',

      'electronicContact',

      'contractSettings.emailVerified',
      'contractSettings.postAddressIsTheSame',
      'insuredSettings.contractedIsInsured',
      'mortgageSettings.propertyIsMortgaged',

      'statementSettings.privacyStatement',
      'statementSettings.insuranceTerms',
      'statementSettings.electronicCommunation',
      'statementSettings.marketingMails',

      'cities',
      'banks',
    ]),
    ...mapFields({
      contractorLastName: 'contractSettings.lastName',
      contractorFirstName: 'contractSettings.firstName',
      contractorMotherChildName: 'contractSettings.motherChildName',
      contractorBornName: 'contractSettings.bornName',
      contractorBornCity: 'contractSettings.bornCity',
      contractorBornDate: 'contractSettings.bornDate',
      contractorPhoneNumberArea: 'contractSettings.phoneNumberArea',
      contractorPhoneNumber: 'contractSettings.phoneNumber',
      contractorEmail: 'contractSettings.email',
      contractorEmailVerification: 'contractSettings.emailVerification',

      contractorLocationZip: 'contractSettings.postAddress.locationZip',
      contractorLocationCity: 'contractSettings.postAddress.locationCity',
      contractorLocationName: 'contractSettings.postAddress.locationName',
      contractorSelectedLocationName: 'contractSettings.postAddress.selectedLocationName',
      contractorLocationType: 'contractSettings.postAddress.locationType',
      contractorLocationHouseNumber: 'contractSettings.postAddress.locationHouseNumber',
      contractorLocationBuilding: 'contractSettings.postAddress.locationBuilding',
      contractorLocationTopography: 'contractSettings.postAddress.locationTopography',

      insuredLastName: 'insuredSettings.lastName',
      insuredFirstName: 'insuredSettings.firstName',
      insuredMotherChildName: 'insuredSettings.motherChildName',
      insuredBornName: 'insuredSettings.bornName',
      insuredBornCity: 'insuredSettings.bornCity',
      insuredBornDate: 'insuredSettings.bornDate',
      insuredPhoneNumberArea: 'insuredSettings.phoneNumberArea',
      insuredPhoneNumber: 'insuredSettings.phoneNumber',
      insuredEmail: 'insuredSettings.email',
      insuredEmailVerification: 'insuredSettings.emailVerification',

      mortgageCreditor: 'mortgageSettings.creditor',
      mortgageCreditorLocation: 'mortgageSettings.creditorLocation',
      mortgageId: 'mortgageSettings.mortgageId',
      mortgagePrice: 'mortgageSettings.mortgagePrice',
      mortgageCurrency: 'mortgageSettings.mortgageCurrency',
      mortgageStartDate: 'mortgageSettings.mortgageStartDate',
      mortgageEndDate: 'mortgageSettings.mortgageEndDate',
    }),
    zipCodes: {
      get() {
        return Object.keys(this.cities);
      },
    },
  },
  methods: {
    getCityNamesByZip: function(zip) {
      const zipCodeList = Object.keys(this.cities);
      if (zipCodeList.length === 0 || (zipCodeList.length > 0 && !zipCodeList.includes(zip)))
        return [];

      const zipData = this.cities[zip];

      if (!zipData) return [];

      return typeof zipData.telepules === 'string'
        ? [zipData.telepules]
        : Object.values(zipData.telepules);
    },
  },
  watch: {
    contractorPhoneNumberArea: function(newVal) {
      if (newVal > 99) this.contractorPhoneNumberArea = 99;
      if (newVal < 0) this.contractorPhoneNumberArea = 1;
    },
    insuredPhoneNumberArea: function(newVal) {
      if (newVal > 99) this.insuredPhoneNumberArea = 99;
      if (newVal < 0) this.insuredPhoneNumberArea = 1;
    },
    mortgageBank: function(newVal, oldVal) {
      const bank = this.banks.find((bank) => bank.id === newVal);
      if (bank) {
        this.mortgageCreditor = bank.name;
        this.mortgageCreditorLocation = bank.address;
      } else {
        if (newVal == '0000000000') {
          //
        } else {
          this.mortgageBank = null;
        }
        this.mortgageCreditor = '';
        this.mortgageCreditorLocation = '';
      }
    },
    contractorLocationZip: function(newVal) {
      this.mailingCityNames = this.getCityNamesByZip(newVal);

      if (this.mailingCityNames.length === 1) {
        this.contractorSelectedLocationName = this.mailingCityNames[0];
      }
    },
  },
};
</script>

<style lang="scss">
.custom-file-label::after {
  content: 'Kiválasztás' !important;
}

.select2-selection__rendered {
  line-height: 38px !important;
}

.select2-container .select2-selection--single {
  height: 38px !important;
  border-color: #ced4da;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.select2-selection__arrow {
  height: 38px !important;
}
</style>
